import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      lists: [{
        name: "微信小程序",
        img: "1",
        isAnimated: false
      }, {
        name: "快应用",
        img: "2",
        isAnimated: false
      }, {
        name: "UNI APP",
        img: "3",
        isAnimated: false
      }, {
        name: "IOS",
        img: "4",
        isAnimated: false
      }, {
        name: "安卓",
        img: "5",
        isAnimated: false
      }, {
        name: "cocos",
        img: "6",
        isAnimated: false
      }, {
        name: "UNITY",
        img: "7",
        isAnimated: false
      }, {
        name: "H5 APP",
        img: "8",
        isAnimated: false
      }, {
        name: "H5 WEB",
        img: "9",
        isAnimated: false
      }, {
        name: "Flutter",
        img: "10",
        isAnimated: false
      }],
      isAnimated: false,
      scrollY: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(); // 初始化位置
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getImagePath(imageName) {
      return require(`../../assets/images/all-${imageName}.png`);
    },
    mouseEnter(activeIndex) {
      this.lists.forEach((item, index) => {
        if (index == activeIndex) {
          item.isAnimated = true;
        } else {
          item.isAnimated = false;
        }
      });
    },
    mouseLeave(activeIndex) {
      this.lists.forEach((item, index) => {
        if (index == activeIndex) {
          item.isAnimated = false;
        }
      });
    },
    handleScroll() {
      if (!this.$refs.outerContainer) return;
      const rect = this.$refs.outerContainer.getBoundingClientRect();
      // const offsetY = -rect.top * 1; // 背景滚动速度
      const offsetY = -rect.top / this.scale * 1; // 视差系数

      // 更新背景位置
      this.$refs.outerContainer.style.backgroundPosition = `center ${offsetY}px`;
    }
  }
};